import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { Fabric } from '../Models/fabric';
import { Observable } from 'rxjs/Observable';
import { LanguageService } from './lang';


@Injectable()
export class FabricService {

  constructor(private http: HttpClient,
              private config: Config,
              private languageService: LanguageService) { }

  list(): Observable<Fabric[]> {
    // fabrics depend on language hence the flatmap
    return this.languageService.getLanguage().flatMap(
      value => {
        return this.http.get<Fabric[]>(this.config.getURL('fabrics'));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/fabric.ts